

import React, { useState, useEffect, useRef } from 'react';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import swal from 'sweetalert';
import { API_URL } from "../../../../constant/API_Settings";

const CardSalesMultiple = ({
  preventNonNumericalInput,
  prevDec,
  hide,
  payment,
  setSuccess,
  // getSummerySheet,
  opedmid,
  edmid,
  opdate,
  setSummary,
  navigate,
  setList,
  list_data,
  setTotal,
  total,
}) => {

  const getCurrentTime = () => moment().format('hh:mm A');

  const [inputGroups, setInputGroups] = useState([
    { payment_method_id: '', time: getCurrentTime(), note: '', card_no: '', amount: '' }
  ]);
  const [localErrors, setLocalErrors] = useState({});
  const [isSaving, setIsSaving] = useState(true);
  const mulDigitalSubmitLockRef = useRef(false);
  const [input2, setInput2] = useState({});
  const [search, setSearch] = useState('');
  const [Loading, setLoading] = useState(false);
  const [pages, setpages] = useState({
    current_page: 1,
    last_page: 0,
    total_pages: 0,
    pagination_item: [],
  });

  const getSummerySheet = () => {
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify({
        op_emp_id: localStorage.getItem('op_emp_id'),
        emp_id: localStorage.getItem('emp_id'),
        op_date: localStorage.getItem('op_date'),
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      },
    };
    fetch(API_URL + "/getSummerySheet", requestOptions)
      .then(response => response.json())
      .then(setSummary)
      .catch(console.log);
  };

  const handlePagination = (number) => {
    setpages({ ...pages, current_page: number });
    ListCardSales(number);
  };

  const ListCardSales = (page) => {
    const requestOptions = {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      },
    };
    fetch(`${API_URL}/card_sales_digital_payment?search_keyword=${search}&page=${page}&emp_id=${localStorage.getItem('emp_id')}&op_emp_id=${localStorage.getItem('op_emp_id')}&op_date=${localStorage.getItem('op_date')}`, requestOptions)
      .then(response => response.json())
      .then(responseData => {
        setLoading(true);
        setList(responseData.data.data);
        setInput2({ ...input2, isdayclose: responseData.isdayclose });
        setTotal({ ...total, totalamount: responseData.total_amount });

        const total_pages = responseData.data.last_page;
        const items = [];
        for (let number = 1; number <= total_pages; number++) {
          items.push(
            <li key={number} className={`page-item ${number === page ? 'active' : ''}`}>
              <a className="page-link" onClick={() => handlePagination(number)}>{number}</a>
            </li>
          );
        }

        setpages({
          current_page: responseData.data.current_page,
          last_page: responseData.data.last_page,
          total_pages: responseData.data.last_page,
          pagination_items: items
        });
      })
      .catch(console.log);
  };

  const releaseMulDigitalSubmitLock = () => {
    mulDigitalSubmitLockRef.current = false;
    setIsSaving(true);
  };

  const sendCard = () => {
    const requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      },
      body: JSON.stringify({
        inputGroups,
        op_emp_id: opedmid,
        emp_id: edmid,
        op_date: opdate
      })
    };

    fetch(`${API_URL}/mul_digitalsales`, requestOptions)
      .then(response => response.json())
      .then(responseData => {
        if (responseData.status === false) {
          setLocalErrors(responseData.response || {});
          if (responseData.message) {
            swal("", responseData.message, "warning");
          }
          releaseMulDigitalSubmitLock();
        } else if (responseData.status === "DENY") {
          swal("", responseData.message, "warning");
          releaseMulDigitalSubmitLock();
        } else if (responseData.status === true) {
          swal("", responseData.message, "success");
          setInputGroups([{ payment_method_id: '', time: getCurrentTime(), note: '', card_no: '', amount: '' }]);
          getSummerySheet();
          ListCardSales(pages.current_page);
          releaseMulDigitalSubmitLock();
          hide();
        }
      })
      .catch(e => {
        console.error(e);
        swal("Something went wrong", "", "warning");
        releaseMulDigitalSubmitLock();
      });
  };

  const handleAddRow = () => {
    setInputGroups([
      ...inputGroups,
      { payment_method_id: '', time: getCurrentTime(), note: '', card_no: '', amount: '' }
    ]);
  };

  const handleRemoveRow = (index) => {
    const rows = [...inputGroups];
    rows.splice(index, 1);
    setInputGroups(rows);
  };

  const handleDynamicInput = (index, e) => {
    const newGroups = [...inputGroups];
    newGroups[index][e.target.name] = e.target.value;
    setInputGroups(newGroups);
  };

  const handleDynamicTimeChange = (index, value) => {
    const newGroups = [...inputGroups];
    newGroups[index].time = value ? value.format('hh:mm A') : '';
    setInputGroups(newGroups);
  };

  const handleSubmit = () => {
    if (mulDigitalSubmitLockRef.current) {
      return;
    }

    const newErrors = {};
    let hasError = false;

    inputGroups.forEach((group, index) => {
      if (!group.payment_method_id) {
        newErrors[`payment_method_id_${index}`] = "Required";
        hasError = true;
      }
      if (!group.amount || parseFloat(group.amount) <= 0) {
        newErrors[`amount_${index}`] = "Required";
        hasError = true;
      }
    });

    if (hasError) {
      setLocalErrors(newErrors);
      return;
    }

    setLocalErrors({});
    mulDigitalSubmitLockRef.current = true;
    setIsSaving(false);
    sendCard();
  };

  return (
    <React.Fragment>
      <div className="modal-overlay" />
      <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
        <div className="modal modal-dialog-xl modalxl">
          <div className="modal-header mb-3">
            <h5 className="text-center">Card Sales / Digital Payment</h5>
            <button type="button" className="modal-close-button" onClick={hide}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <table className="table table-bordered table-striped text-center align-middle">
              <thead className="thead-dark">
                <tr>
                  <th>Payment Type <span className="text-danger">*</span></th>
                  <th>Time</th>
                  <th>Description</th>
                  <th>Card Number</th>
                  <th>Amount <span className="text-danger">*</span></th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {inputGroups.map((group, index) => (
                  <tr key={index}>
                    <td>
                      <select
                        name="payment_method_id"
                        className="form-control"
                        value={group.payment_method_id}
                        onChange={(e) => handleDynamicInput(index, e)}
                      >
                        <option value="">Select</option>
                        {payment.map((data, idx) => (
                          <option key={idx} value={data[0]}>{data[1]}</option>
                        ))}
                      </select>
                      <div className="errorMsg">{localErrors[`payment_method_id_${index}`]}</div>
                    </td>
                    <td>
                      <TimePicker
                        showSecond={false}
                        value={group.time ? moment(group.time, 'hh:mm A') : null}
                        onChange={(value) => handleDynamicTimeChange(index, value)}
                        className="digitaltimepicker"
                        use12Hours
                        inputReadOnly={false}
                        allowEmpty={false}
                        placeholder="hh:mm AM/PM"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        name="note"
                        value={group.note}
                        onChange={(e) => handleDynamicInput(index, e)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control hide-arrow"
                        name="card_no"
                        value={group.card_no}
                        onKeyPress={(e) => prevDec(e, e.target.value)}
                        onChange={(e) => handleDynamicInput(index, e)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control hide-arrow"
                        name="amount"
                        value={group.amount}
                        onKeyPress={(e) => preventNonNumericalInput(e, e.target.value)}
                        onChange={(e) => handleDynamicInput(index, e)}
                      />
                      <div className="errorMsg">{localErrors[`amount_${index}`]}</div>
                    </td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemoveRow(index)}
                        disabled={inputGroups.length === 1}
                      >-</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="text-center my-3">
              <button className="btn btn-success" onClick={handleAddRow}>+ Add</button>
            </div>

            {localStorage.getItem("save_hide") === 'false' && (
              <div className="modal-footer text-center">
                <button className="btn btn-danger w-auto" onClick={hide}>Cancel</button>
                {isSaving ? (
                  <button className="btn btn-primary px-4 w-auto" onClick={handleSubmit}>SAVE</button>
                ) : (
                  <button className="btn btn-primary px-4 w-auto" disabled>SAVE</button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardSalesMultiple;
